<ng-container *ngIf="!requestSent; else successState">
  <div class="flex flex-col h-full sm:h-auto justify-between sm:justify-start gap-6">
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-1 bg-green-50 text-green-700 text-sm font-medium px-2 py-1 rounded w-fit">
          <span class="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"></span>
          New Opportunity
        </div>
        <h2 class="text-3xl font-normal text-Gray-1000">Your Next Investment Is Waiting</h2>
        <p class="text-base">A new loan participation opportunity is now live. View it on our Participation Portal or request access below</p>
      </div>

      <div class="flex flex-col sm:flex-row bg-Gray-100 rounded-lg overflow-hidden">
        <div class="w-full h-48 sm:w-[180px] sm:h-auto shrink-0">
          <img src="assets/images/majestic_hotel.svg" alt="Property image" class="w-full h-full object-cover">
        </div>
        <div class="flex flex-col justify-center gap-1.5 p-4">
          <p class="text-base font-bold text-Gray-1000">The Majestic Hotel</p>
          <div class="flex flex-wrap gap-4">
            <span class="flex items-center gap-1.5 text-sm">
              <span class="material-symbols-rounded text-green-600">distance</span>
              San Francisco, CA 94102
            </span>
            <span class="flex items-center gap-1.5 text-sm">
              <span class="material-symbols-rounded text-green-600">home_work</span>
              Hospitality
            </span>
          </div>
          <div class="flex flex-wrap gap-4 text-sm">
            <span><span class="font-medium text-Gray-800 mr-2">LTV:</span>50.00%</span>
            <span><span class="font-medium text-Gray-800 mr-2">Loan Amount:</span>$6,600,000</span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row sm:divide-x divide-Gray-400 gap-4 sm:gap-0">
      <div class="flex-1 flex flex-col items-center gap-2 sm:pr-4">
        <p class="text-sm text-Gray-800">Don't have an account yet?</p>
        <button
          class="w-full flex items-center justify-center gap-2 border border-Gray-400 text-Gray-1000 font-medium rounded-lg text-base px-6 py-3 hover:bg-Gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          (click)="join()" [disabled]="isJoining">
          <i *ngIf="isJoining" class="pi pi-spin pi-spinner"></i>
          {{ isJoining ? 'Requesting...' : 'Join the Participation Portal' }}
        </button>
      </div>
      <div class="flex-1 flex flex-col items-center gap-2 sm:pl-4">
        <p class="text-sm text-Gray-800">Already a member?</p>
        <button class="w-full bg-main text-white font-medium rounded-lg text-base px-6 py-3 hover:bg-green-600" (click)="view()">View Opportunity</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #successState>
  <div class="flex flex-col h-full sm:h-auto justify-between sm:justify-start gap-6">
    <div class="flex flex-col gap-4">
      <div class="w-10 h-10 bg-green-50 rounded flex items-center justify-center">
        <span class="material-symbols-rounded text-green-500">check_circle</span>
      </div>
      <div class="flex flex-col gap-2">
        <h2 class="text-2xl font-semibold text-Gray-1000">Access Request Received</h2>
        <p class="text-base text-Gray-800">Your Participation Portal account will be ready within 1 business day. We'll email you your login details — then you can dive into this and all other available opportunities</p>
      </div>
    </div>
    <div class="flex justify-center">
      <button
      class="w-full sm:w-fit border border-Gray-400 text-Gray-1000 font-medium rounded-lg text-base px-6 py-3 hover:bg-Gray-100 transition-colors"
      (click)="done()">
      Done
    </button>
    </div>
  </div>
</ng-template>
